<div [formGroup]="form" class="container">
  <mat-form-field class="status-select">
    <mat-select [formControlName]="controlName" [style]="getSelectedItemStyle()" (selectionChange)="changed($event)">
      <mat-option>{{ emptyDisplayValue }}</mat-option>
      @for (state of states; track state) {
        <mat-option [value]="state.id" [style]="getItemStyle(state)">{{
          state.text
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
